// extracted by mini-css-extract-plugin
module.exports = {"input":"_2787e5dfdf--input--vbY5n","button":"_2787e5dfdf--button--DJvnM"};